<template>
  <div class="pt-5">
    <h1>Resources</h1>

    <div class="mt-5 pt-3 pl-3 pr-3 pb-3 bg-light border rounded">
      <h6 class="text-uppercase font-poppins">
        Codes
        <em>({{ resourcesFiltered.length }} codes)</em>
      </h6>

      <div v-for="r in resourcesFiltered" :key="r.id" class="mt-3 pt-3 border-top">
        <router-link :to="{ name: 'ProjectResource', params: { resourceId: r.id } }">
          <strong>
            {{ r.title }}
          </strong>
        </router-link>

        <b-badge v-if="r.state === STATES.VIGUEUR" variant="success" class="ml-2" pill>En Vigueur</b-badge>
        <b-badge v-else-if="r.state === STATES.ABROGE" variant="danger" class="ml-2" pill>Abrogé</b-badge>

        <br />
        <em>Version au {{ convertLegifranceDateToDate(r.createdAt) }}</em>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { BBadge } from "bootstrap-vue";

import { STATES } from "@/constants/resources";

import { convertLegifranceDateToDate } from "@/helpers/date";

export default {
  name: "Resources",
  components: { BBadge },
  computed: {
    ...mapGetters("projectsResources", ["itemsSorted"]),
    resources() {
      return this.itemsSorted;
    },
    resourcesFiltered() {
      const { filterState } = this;

      if (filterState) return this.resources.filter(({ state }) => state === filterState);
      return this.resources;
    },
  },
  data: () => ({
    filterState: STATES.VIGUEUR,

    STATES,
  }),
  methods: { convertLegifranceDateToDate },
};
</script>
